<template>
    <div class="app-digi" id="full-screen">
        <div class="horizontal-layout-1" v-if="loadingGif">
            <div class="d-flex justify-content-center align-items-center w-100 h-100">
                <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" class="mx-auto" />
            </div>
        </div>
        <div class="w-100 h-100" v-else>
            <div class="horizontal-layout-1" v-if="!showaccess">
                <div id="main" class="chrome" v-if="loggedIn && otpVerified && !register">
                    <div class="digitop">
                        <Navbar :version="version" product_name="DigiHRMS" :toggleShow="toggleShow" :route_top_menus="route_top_menus" @SwitchCompanySuccess="SwitchCompanySuccess" :auth_token="auth_token" />
                    </div>
                    <div class="digicontainer">
                        <div class="dccontainer">
                            <section class="ps-container w-100 ps ps--theme_default">
                                <div class="bigcontainer" ref="containerDiv" id="containerDiv">
                                    <div class="content-blocks h-100" :class="{'content-boxnew':toggleShow == true}">
                                        <Sidebar class="d-flex flex-column flex-row-auto" product_name="DigiHRMS" :route_menus="route_menus"  @handleToggleShow="handleToggleShow"></Sidebar>
                                        <div class="p-0 position-relative ml-mdnsmall-100px content-block-router zIndex-0 min-h-90per" id="router-relative">
                                            <router-view />
                                        </div>
                                        <div class="bottom-0px">
                                            <!-- <foot :version="version"></foot> -->
                                            <Footer :version="version" product_name="DigiHRMS" />
                                        <!-- <footer-bottom></footer-bottom> -->
                                            <!-- <foot></foot> -->
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                    <div class="mt-3 justify-content-center animated" style="display: flex; z-index: 99999 !important;" :class="{'in-down':switch_success == false || switch_success,'d-none':!switch_success,'fadeOut': switch_success == false}" v-if="switch_success">
                        <switch-company-success @hideSuccess="hideSuccess" :success_message="switch_comp_success_message" modal_name="switch-success" style="z-index:9999 !important"></switch-company-success>
                    </div>
                </div>
                <div class="horizontal-layout-1" v-else-if="register || !otpVerified">
                    <div id="main">
                        <router-view/>
                    </div>
                </div>
            </div>
            <div class="horizontal-layout-1" v-if="showaccess">
                <div id="main" class="chrome">
                    <div class="digitop">
                        <nav-top></nav-top>
                    </div>
                    <div class="digicontainer">
                        <div class="dccontainer">
                            <section class="ps-container w-100 ps ps--theme_default">
                                <div class="bigcontainer" ref="containerDiv" id="containerDiv">
                                    <div class="content-blocks pl-4 pr-3">
                                        <div class="content-block-router">
                                            <access-denied></access-denied>
                                        </div>
                                    </div>
                                    <div class="p-0 position-relative">
                                        <!-- <footer-bottom></footer-bottom> -->
                                        <!-- <Footer :version="version" product_name="DigiHRMS" /> -->
                                            <foot :version="version"></foot>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <switch-accessable-company :user_has="user_has" :comp_data="comp_data" modal_name="SwitchAccessableCompany" :error_msg="error_msg" v-if="switch_accessable" @DeleteSessionToken="DeleteSessionToken" @hideSwitchAccessableCompany="hideSwitchAccessableCompany"></switch-accessable-company>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
	</div>
</template>
<script>
import axios from "axios";
import {EventBus} from './components/eventBus/nav-bar-event';
import global from "./components/global.js"
import { SweetModal } from 'sweet-modal-vue';
import { Sidebar } from '@digicollect_front_end/digi-fe-library';
// import  Sidebar  from './components/Sidebar.vue';
import { Navbar } from '@digicollect_front_end/digi-fe-library';
// const Foot = () => import('./components/FooterNew');
import { Footer } from '@digicollect_front_end/digi-fe-library';
// import Footer from '@/components/FooterNew';
const AccessDenied = () => import('./components/AccessDenied');
// const FooterBottom = () => import('./components/FooterBottom');
import {SwitchCompanySuccess} from '@digicollect_front_end/digi-fe-library'
const SwitchAccessableCompany = () => import('./components/alertModals/SwitchAccessableCompany')
const NavTop = () => import('./components/NavTop');
import navbarMixin from './components/mixins/navbarMixin'
import { HalfCircleSpinner } from "epic-spinners";
export default {
    name: 'App',
    mixins:[navbarMixin],
    data(){
        return{
            auth_token: '',
            version: 'v1.0.0.a123',
            version_test: "v1.0.0.a123",
            version_prod: "V3.0.3",
            toggleShow: false,
            error_msg: '',
            fcmToken: "",
            success_msg: '',
            warning_msg: '',
            firebaseServerKey: "AAAAbYnlazc:APA91bHIjq3SWC3cEyTPmxipH3jg_HDG5DDksHOZbpCbi4o9ZxU6Jm259Fdf-URMogP5w_ebYvghDd7HqpPcNZud3FcSqo_RlAK4vK0tsoA0hGxQiktSFFUlrWtmHVf4hsv2hDSUQztZ",
            loadingGif: true,
            showaccess:false,
            status_code: null,
            loggedIn: false,
            otpVerified: false,
            registered: true,
            register: false,
            isTablet: false,
            isIpad: false,
            loadingApp: false,
            mobileView: false,
            warning_msg: '',
            stored_session_id: "",
            user_has: '',
            company_id: '',
            switch_accessable: false,
            route_menus: [
                {
                    name: 'Dashboard',
                    sm_name: 'Dash',
                    route: '/',
                    hover: false,
                    logo: {
                        inactive: 'digi-hrms1',
                        active: 'digi-hrms1',
                    },
                    route_names: ['New Home Dashboard'],
                    permitted_roles: ['admin', 'employee', 'hr'],
                    selected: true,
                    toggle_submenu: false
                },
                {
                    name: 'User Portal',
                    sm_name: 'User',
                    route_names: ['Employee Info List', 'Employee Edit', 'Employee View', 'View Employee', 'Employee Create', 'Employee Edit'],
                    submenus: [
                        // {
                        //     name: 'Dashboard',
                        //     route: '',
                        //     sub_route_names: [''],
                        //     sub_route_queries: [],
                        //     permitted_roles: ['owner', 'admin'],
                        //     sub_route_params: [],
                        //     selected: false
                        // },
                        {
                            name: 'My Information',
                            route: '',
                            sub_route_names: ["Employee View", "View Employee", "Employee Create", "Employee Edit"],
                            sub_route_params: [],
                            permitted_roles: ['admin', 'employee', 'hr'],
                            sub_route_queries: [],
                            selected: false,
                            emitter: false
                        },
                        {
                            name: "Employee's List",
                            route: '/employee_info/list',
                            sub_route_names: ["Employee Info List"],
                            sub_route_params: [],
                            permitted_roles: ['admin', 'hr'],
                            sub_route_queries: [],
                            selected: false,
                            emitter: false
                        },
                        // {
                        //     name: 'Benefits',
                        //     route: '',
                        //     sub_route_names: [''],
                        //     sub_route_params: [],
                        //     permitted_roles: ['owner', 'admin'],
                        //     sub_route_queries: [],
                        //     selected: false
                        // },
                        {
                            name: 'Onboarding',
                            route: '/employee_info/list?is_draft=false',
                            sub_route_names: [],
                            sub_route_params: [],
                            permitted_roles: ['admin', 'hr'],
                            sub_route_queries: [],
                            selected: false,
                            emitter: true
                        }
                        
                    ],
                    hover: false,
                    logo: {
                        inactive: 'digi-hrms2',
                        active: 'digi-hrms2',
                    },
                    permitted_roles: ['admin', 'employee', 'hr'],
                    toggle_submenu: false
                },
                {
                    name: 'Payroll',
                    sm_name: 'Payroll',
                    route_names: ['Payrolls List', 'Payslip', 'Employee Payroll', 'Payroll Dashboard'],
                    submenus: [
                        {
                            name: 'Dashboard',
                            route: '/payroll_dashboard',
                            sub_route_names: ['Payroll Dashboard'],
                            sub_route_params: [],
                            permitted_roles: ['owner', 'admin', 'hr', 'employee'],
                            sub_route_queries: [],
                            emitter: false
                        },
                        {
                            name: 'My Payroll (Payslips)',
                            route: '/employee_info/payrolls/list/my_payroll',
                            sub_route_names: ['Payrolls List', 'Payslip'],
                            sub_route_params: [{type: 'my_payroll'}],
                            permitted_roles: ['admin', 'employee', 'hr'],
                            sub_route_queries: [],
                            emitter: false
                        },
                        {
                            name: "Employee's Payroll (Payslips)",
                            route: '/employee_info/payrolls/list/employee_payroll',
                            sub_route_names: ['Payrolls List', 'Payslip'],
                            sub_route_params: [{type: 'employee_payroll'}],
                            permitted_roles: ['admin', 'hr'],
                            sub_route_queries: [],
                            selected: false,
                            emitter: false
                        },
                    ],
                    hover: false,
                    logo: {
                        inactive: 'ri-exchange-dollar-line',
                        active: 'ri-exchange-dollar-line',
                    },
                    selected: false,
                    permitted_roles: ['admin', 'employee', 'hr'],
                    toggle_submenu: false
                },
                {
                    name: 'Attendance',
                    sm_name: 'Attend',
                    route_names: ["Employee Attendance", 'HR Attendance', 'Timesheet List', 'Timesheet', 'CreateTravel', 'TravelView', 'DraftTravelView', 'TravelListView', 'EditTravelView', 'EditDraftTravelView'],
                    submenus: [
                        {
                            name: 'Attendance List',
                            route: '/employee_info/attendance_list',
                            sub_route_queries: [],
                            sub_route_params: [],
                            sub_route_names: ["Employee Attendance", 'HR Attendance'],
                            selected: false,
                            permitted_roles: ['admin', 'employee', 'hr'],
                            emitter: false
                        },
                        {
                            name: 'My Shift Details',
                            route: '/employee_info/timesheet/list/my_timesheet',
                            sub_route_queries: [],
                            sub_route_params: [{type: 'my_timesheet'}],
                            sub_route_names: ['Timesheet List'],
                            selected: false,
                            permitted_roles: ['admin', 'employee', 'hr'],
                            emitter: false
                        },
                        {
                            name: "Employee's Shift Details",
                            route: '/employee_info/timesheet/list/manage_timesheet',
                            sub_route_queries: [],
                            sub_route_params: [{type: 'manage_timesheet'}],
                            sub_route_names: ['Timesheet List'],
                            selected: false,
                            permitted_roles: ['admin', 'hr'],
                            emitter: false
                        },
                        {
                            name: 'Timesheet',
                            route: '/timesheet?type=my_timesheet',
                            sub_route_queries: [],
                            sub_route_params: [],
                            sub_route_names: ["Timesheet"],
                            selected: false,
                            permitted_roles: ['admin', 'employee', 'hr'],
                            emitter: false
                        },
                        // {
                        //     name: 'Travel Registry',
                        //     route: '/travel_registry/list',
                        //     sub_route_queries: [],
                        //     sub_route_params: [],
                        //     sub_route_names: ['CreateTravel', 'TravelView', 'DraftTravelView', 'TravelListView', 'EditTravelView', 'EditDraftTravelView'],
                        //     selected: false,
                        //     permitted_roles: ['admin', 'employee', 'hr'],
                        //     emitter: false
                        // },
                        {
                        name: 'Travel Registry',
                        route: '',
                        sub_route_names: ['CreateTravel', 'TravelView', 'DraftTravelView', 'TravelListView', 'EditTravelView', 'EditDraftTravelView'],
                        sub_route_params: [],
                        permitted_roles: ['admin', 'employee', 'hr'],
                        sub_route_queries: [],
                        // meta: { breadcrumb: 'Archive Reports' },
                        toggle_submenu: false,
                        submenus: [
                                {
                                    name: 'Create',
                                    route: '/travel_registry/create',
                                    selected: false,
                                    permitted_roles: [],
                                    sub_route_queries: [],
                                    sub_route_params: [],
                                    sub_route_names: ['CreateTravel'],
                                    // meta: { breadcrumb: 'Approval Reports' },
                                },
                                {
                                    name: 'List View',
                                    route: '/travel_registry/list',
                                    selected: false,
                                    permitted_roles: [],
                                    sub_route_queries: [],
                                    sub_route_params: [],
                                    sub_route_names: ['TravelView', 'DraftTravelView', 'TravelListView', 'EditTravelView', 'EditDraftTravelView'],
                                    // meta: { breadcrumb: 'Pre Approval Reports' },
                                },
                            ],
                            selected: false
                        }
                    ],
                    hover: false,
                    logo: {
                        inactive: 'digi-hrms4',
                        active: 'digi-hrms4',
                    },
                    permitted_roles: [ 'admin', 'employee', 'hr'],
                    toggle_submenu: false
                },
                // {
                //     name: 'Timesheet List',
                //     sm_name: 'Time',
                //     route: '/timesheet?type=my_timesheet',
                //     hover: false,
                //     logo: {
                //         inactive: 'digi-hrms1',
                //         active: 'digi-hrms1',
                //     },
                //     route_names: ['Timesheet'],
                //     permitted_roles: ['admin', 'employee', 'hr'],
                //     selected: true,
                //     toggle_submenu: false
                // },
                {
                    name: 'LMS',
                    sm_name: 'LMS',
                    route_names: ['Employee Leave List View', 'Employee OT List View', 'Employee Leave Details', 'Check Available Leaves', 'Apply Leaves', 'Apply OT', 'Apply Leaves', 'Employee OT Details'],
                    submenus: [
                        // {
                        //     name: 'Dashboard',
                        //     route: '',
                        //     sub_route_queries: [],
                        //     sub_route_params: [],
                        //     sub_route_names: [''],
                        //     selected: false,
                        //     permitted_roles: ['owner', 'admin', 'employee']
                        // },
                        {
                            name: 'My Leave Log',
                            route: '/employee_info/leave_list/my_leave',
                            sub_route_queries: [],
                            sub_route_params: [{type: "my_leave"}],
                            sub_route_names: ['Employee Leave List View', 'Employee Leave Details', 'Check Available Leaves', 'Apply Leaves'],
                            selected: false,
                            permitted_roles: ['admin', 'employee', 'hr'],
                            emitter: false
                        },
                        {
                            name: 'Leave Management',
                            route: '/employee_info/leave_list/manage_leave',
                            sub_route_queries: [],
                            sub_route_params: [{type: "manage_leave"}],
                            sub_route_names: ['Employee Leave List View', 'Employee Leave Details', 'Check Available Leaves'],
                            selected: false,
                            permitted_roles: ['admin', 'employee', 'hr'],
                            emitter: false
                        },
                        {
                            name: 'My OT Log',
                            route: '/employee_info/ot_list/my_ot',
                            sub_route_queries: [],
                            sub_route_params: [{type: "my_ot"}],
                            sub_route_names: ['Employee OT List View', 'Apply OT', 'Employee OT Details'],
                            selected: false,
                            permitted_roles: ['admin', 'employee', 'hr'],
                            emitter: false
                        },
                        {
                            name: 'Manage OT Log',
                            route: '/employee_info/ot_list/manage_ot',
                            sub_route_queries: [],
                            sub_route_params: [{type: "manage_ot"}],
                            sub_route_names: ['Employee OT List View', 'Apply OT', 'Employee OT Details'],
                            selected: false,
                            permitted_roles: ['admin', 'employee', 'hr'],
                            emitter: false
                        },
                    ],
                    hover: false,
                    logo: {
                        inactive: 'digi-hrms5',
                        active: 'digi-hrms5',
                    },
                    permitted_roles: ['admin', 'employee', 'hr'],
                    toggle_submenu: false
                },
                {
                    name: 'Assets',
                    sm_name: 'Assets',
                    route_names: ['Employee Assets', 'Employee Asset By Details', 'Asset Dashboard'],
                    submenus: [
                        // {
                        //     name: 'Dashboard',
                        //     route: '',
                        //     sub_route_queries: [],
                        //     sub_route_params: [],
                        //     sub_route_names: [''],
                        //     selected: false,
                        //     permitted_roles: ['owner', 'admin']
                        // },
                        {
                            name: 'List View',
                            route: '/employee_info/assets_list',
                            sub_route_queries: [],
                            sub_route_params: [],
                            sub_route_names: ['Employee Assets', 'Employee Asset By Details'],
                            selected: false,
                            permitted_roles: ['admin', 'hr', 'employee'],
                            emitter: false
                        },
                    ],
                    hover: false,
                    logo: {
                        inactive: 'digi-file-shield-line',
                        active: 'digi-file-shield-line',
                    },
                    permitted_roles: [ 'admin', 'employee', 'hr'],
                    toggle_submenu: false
                },
                {
                    name: 'Settings',
                    sm_name: 'Settings',
                    route_names: ['Settings'],
                    submenus: [
                        {
                            name: 'General',
                            route: '/settings?type=general_settings&sub_type=attendance_scheme',
                            sub_route_queries: [{type:'general_settings', sub_type: 'attendance_scheme'}],
                            sub_route_params: [],
                            sub_route_names: ['Settings'],
                            selected: false,
                            permitted_roles: [ 'admin','employee','user', 'hr'],
                            emitter: false
                        },
                        {
                            name: 'LMS (Leave Management)',
                            route: '/settings?type=lms_settings&sub_type=paid_time_off',
                            sub_route_queries: [{type:'lms_settings', sub_type: 'paid_time_off'}],
                            sub_route_params: [],
                            sub_route_names: ['Settings'],
                            selected: false,
                            permitted_roles: ['admin', 'hr'],
                            emitter: false
                        },
                        {
                            name: 'Payroll',
                            route: '/settings?type=payroll_settings&sub_type=earning_type',
                            sub_route_queries: [{type:'payroll_settings', sub_type: 'earning_type'}],
                            sub_route_params: [],
                            sub_route_names: ['Settings'],
                            selected: false,
                            permitted_roles: ['admin', 'hr'],
                            emitter: false
                        },
                    ],
                    hover: false,
                    logo: {
                        inactive: 'digi-hrms7',
                        active: 'digi-hrms7',
                        hover: false
                    },
                    permitted_roles: ['admin', 'hr'],
                    toggle_submenu: false
                },
                // {
                //     name: 'Face Detection',
                //     sm_name: 'Face',
                //     route: '/facerecognize',
                //     hover: false,
                //     logo: {
                //         inactive: 'digi-hrms1',
                //         active: 'digi-hrms1',
                //     },
                //     route_names: ['FaceDetection', 'FaceDetections'],
                //     permitted_roles: ['admin', 'employee', 'hr'],
                //     selected: false,
                //     // emitter: false
                // },
                // {
                //     name: 'Policies',
                //     route: '',
                //     hover: false,
                //     logo: {
                //         inactive: 'digi-hrms8',
                //         active: 'digi-hrms8',
                //     },
                //     route_names: [''],
                //     permitted_roles: ['owner', 'admin'],
                //     toggle_submenu: false
                // },
                // {
                //     name: 'Job Portal',
                //     route: '',
                //     hover: false,
                //     logo: {
                //         inactive: 'digi-hrms9',
                //         active: 'digi-hrms9',
                //     },
                //     route_names: [''],
                //     permitted_roles: ['owner', 'admin'],
                //     toggle_submenu: false
                // },
                // {
                //     name: 'Performance',
                //     route_names: [''],
                //     submenus: [
                //         {
                //             name: 'Performance Review',
                //             route: '',
                //             sub_route_queries: [],
                //             sub_route_params: [],
                //             sub_route_names: [''],
                //             selected: false,
                //             permitted_roles: [ 'admin','super_admin','manager','owner','team_lead','employee','user']
                //         },
                //         {
                //             name: 'Promotions',
                //             route: '',
                //             sub_route_queries: [],
                //             sub_route_params: [],
                //             sub_route_names: [''],
                //             selected: false,
                //             permitted_roles: ['admin','super_admin','manager','owner','team_lead']
                //         },
                //         {
                //             name: 'Terminations',
                //             route: '',
                //             sub_route_queries: [],
                //             sub_route_params: [],
                //             sub_route_names: [''],
                //             selected: false,
                //             permitted_roles: ['admin','super_admin','manager','owner','team_lead']
                //         },
                //     ],
                //     hover: false,
                //     logo: {
                //         inactive: 'digi-hrms10',
                //         active: 'digi-hrms10',
                //         hover: false
                //     },
                //     permitted_roles: ['admin','super_admin','manager','owner','team_lead','employee','user'],
                //     toggle_submenu: false
                // },
                {
                    name: 'Dashboard',
                    sm_name: 'Dash',
                    route: '/attendance_management/dashboard',
                    hover: false,
                    logo: {
                        inactive: 'digi-hrms1',
                        active: 'digi-hrms1',
                    },
                    route_names: ['Attendance Management Dashboard'],
                    permitted_roles: ['attendance manager'],
                    selected: false,
                    toggle_submenu: false
                },
                {
                    name: 'Attendance',
                    sm_name: 'Attend',
                    route: '/attendance_management/clock_in_out',
                    hover: false,
                    logo: {
                        inactive: 'digi-hrms4',
                        active: 'digi-hrms4',
                    },
                    route_names: ['Clock In Out'],
                    permitted_roles: ['attendance manager'],
                    selected: false,
                    toggle_submenu: false
                },
                {
                    name: "Employee's",
                    sm_name: 'Emp',
                    route: '/attendance_management/register_employees_list',
                    hover: false,
                    logo: {
                        inactive: 'digi-hrms2',
                        active: 'digi-hrms2',
                    },
                    route_names: ['Register Employees List'],
                    permitted_roles: ['attendance manager'],
                    selected: false,
                    toggle_submenu: false
                },
            ],
            route_top_menus: [
                {
                    name: 'Dashboard',
                    route: '/attendance_management/dashboard',
                    hover: false,
                    logo: {
                        inactive: 'digi-hrms1',
                        active: 'digi-hrms1',
                    },
                    route_names: ['Attendance Management Dashboard'],
                    permitted_roles: ['attendance manager'],
                    selected: false,
                    toggle_submenu: false
                },
                {
                    name: 'Attendance',
                    route: '/attendance_management/clock_in_out',
                    hover: false,
                    logo: {
                        inactive: 'digi-hrms4',
                        active: 'digi-hrms4',
                    },
                    route_names: ['Clock In Out'],
                    permitted_roles: ['attendance manager'],
                    selected: false,
                    toggle_submenu: false
                },
                {
                    name: 'Dashboard',
                    route: '/',
                    hover: false,
                    logo: {
                        inactive: 'digi-hrms1',
                        active: 'digi-hrms1',
                    },
                    route_names: ['New Home Dashboard'],
                    permitted_roles: ['owner', 'admin', 'hr', 'employee'],
                    selected: true,
                    toggle_submenu: false
                },
                {
                    name: 'Attendance',
                    route: '/employee_info/attendance_list',
                    hover: false,
                    logo: {
                        inactive: 'digi-hrms1',
                        active: 'digi-hrms1',
                    },
                    route_names: ['Employee Attendance'],
                    permitted_roles: ['owner', 'admin', 'hr'],
                    selected: true,
                    toggle_submenu: false
                },
                {
                    name: 'Payroll',
                    route: '/payroll_dashboard',
                    hover: false,
                    logo: {
                        inactive: 'digi-hrms1',
                        active: 'digi-hrms1',
                    },
                    route_names: ['Payrolls List'],
                    permitted_roles: ['employee', 'admin', 'hr'],
                    selected: true,
                    toggle_submenu: false
                },
                // {
                //     name: 'Payroll',
                //     route: '/payroll_dashboard',
                //     hover: false,
                //     logo: {
                //         inactive: 'digi-hrms1',
                //         active: 'digi-hrms1',
                //     },
                //     route_names: ['Payroll Dashboard'],
                //     permitted_roles: ['owner', 'employee', 'admin', 'hr'],
                //     selected: true,
                //     toggle_submenu: false
                // },
                // {
                //     name: 'Analytics',
                //     route_names: [],
                //     route: '',
                //     hover: false,
                //     logo: {
                //         inactive: 'digi-hrms1',
                //         active: 'digi-hrms1',
                //     },
                //     route_names: [],
                //     permitted_roles: ['owner', 'admin', 'hr', 'employee'],
                //     selected: true,
                //     toggle_submenu: false
                // },
            ],
            switch_success: false,
            switch_comp_success_message: '',
            new_token: '',
            user_company: [],
            org_comp_count: 0,
            scroll_flag: false,
            comp_data: [],
            skip: 0,
            search_key: '',
            comp_limit: 10,
        }
    },
    components:{
        Navbar,
        // Foot,
        SwitchCompanySuccess,
        AccessDenied,
        // FooterBottom,
        NavTop,
        SwitchAccessableCompany,
        SweetModal,
        HalfCircleSpinner,
        Sidebar,
        Footer
    },
    methods:{
        setCookie(days) {
            var expires = "";
            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                expires = "; expires=" + date.toUTCString();
            }
           	document.cookie = "Token" + "=" + (this.new_token || "") + expires + ";domain=.digicollect.com; path=/";
        },
        hideSuccess() {
            this.switch_success = false;
            this.setCookie(7);
            setTimeout(() => {
                axios.defaults.headers.common.Authorization = this.$cookie.get("Token");
                
                // ==================== OLD CODE (Commented for reference) ====================
                // Old code: Always redirected to home page after company switch
                // window.location.href = global.HRMS_URL;
                // ==================== END OLD CODE ====================
                
                // ==================== NEW CODE (Deep Linking Support) ====================
                // Modified to check for stored redirect and redirect to intended destination
                const post_switch_redirect = localStorage.getItem('post_switch_redirect');
                if (post_switch_redirect) {
                    localStorage.removeItem('post_switch_redirect'); // Clean up
                    window.location.href = post_switch_redirect;
                } else {
                    window.location.href = global.HRMS_URL;
                }
                // ==================== END NEW CODE ====================
            }, 500);
            EventBus.$emit('ZindexChangeEnd')
        },
        async getOrganizationAndComp() {
            try {
                let param = {
                    skip: this.skip,
                    limit: this.comp_limit,
                    search_key: this.search_key,
                    is_company_switcher: true,
                    product: "DigiHRMS"
                };
                let response = await this.getHierarchyListView(param);
                if(response.status_id == 1) {
                    this.comp_data = response.response;
                    this.user_company = response.user_company;
                    if(this.user_has == 'organization') {
                        this.comp_data.forEach((element, index) => {
                            element['org_active'] = false
                            element.company_list.forEach((element1, index1) => {
                                if(element1.selected) {
                                    this.outer_el = index;
                                    this.inner_el = index1;
                                }
                                return;
                            });
                            return;
                        });
                        var element = this.comp_data[this.outer_el];
                        var element1 = element.company_list[this.inner_el];
                        element.company_list.splice(this.inner_el, 1);
                        element.company_list.splice(0, 0, element1);
                        this.comp_data.splice(this.outer_el, 1);
                        this.comp_data.splice(0, 0, element);
                    } else if(this.user_has == 'company') {
                        this.comp_data.forEach((element, index) => {
                            if(element.selected) {
                                this.outer_el = index;
                            }
                            return;
                        });
                        var element = this.comp_data[this.outer_el];
                        this.comp_data.splice(this.outer_el, 1);
                        this.comp_data.splice(0, 0, element);
                    }
                    this.org_comp_count = response.response.length;
                }
            }
            catch(err) {
            }
        },
        hideSwitchAccessableCompany(){
            EventBus.$emit('ZindexChangeEnd')
            this.switch_accessable = false
            location.reload()
        },
        handleToggleShow(show_name){
            this.toggleShow = show_name
        },
        SwitchCompanySuccess(message){
            try{
                this.new_token = message.token
                this.switch_comp_success_message = message.message
                this.switch_success = true
                
                // ==================== NEW CODE (Deep Linking Support) ====================
                // Store redirect_to if it exists, so hideSuccess can use it
                if (this.$route.query.redirect_to) {
                    localStorage.setItem('post_switch_redirect', this.$route.query.redirect_to);
                } else if (this.$route.fullPath && this.$route.fullPath !== '/') {
                    localStorage.setItem('post_switch_redirect', window.location.origin + this.$route.fullPath);
                }
                // ==================== END NEW CODE ====================
                
                setTimeout(() => {
                    this.$modal.show('switch-success');
                }, 500);
            } catch(err){
            }
        },
        // Geting Logged In User and Set Token
        getLoggedInUser() {
            this.$http.get(global.AUTH_SERVICE + "/auth/get_loggedin_user").then(response => {
                if (response.data.status_id == 1) {
                    this.showAccess = false;
                    axios.defaults.headers.common.Authorization = this.$cookie.get("Token");
                    this.$store.commit('setSessionId', response.data.response.session_id)
                    this.$store.commit('setUserId', response.data.response.user_id)
                    this.stored_session_id = response.data.response.session_id;
                    this.company_id = response.data.response.admin_id
                    this.user_has = response.data.response.user_has
                    if (response.data.response.is_verified) {
                        this.loggedIn = true;
                        this.$store.commit('setloggedInUserCompanyId', response.data.response.company_id);
                        this.otpVerified = true;
                        this.registerInterceptors();
                        this.HRMSLoggedInUser()
                    } else {
                        // ==================== OLD CODE (Commented for reference) ====================
                        // Old code: Simply redirected to OTP page without preserving intended destination
                        // this.$router.push("/verifyOtp").catch((err) => {});
                        // ==================== END OLD CODE ====================
                        
                        // ==================== NEW CODE (Deep Linking Support) ====================
                        // Modified to preserve redirect_to parameter when redirecting to OTP verification
                        // This ensures that after OTP verification, user goes to intended destination
                        if (this.$route.query.redirect_to) {
                            this.$router.push({ path: "/verifyOtp", query: { redirect_to: this.$route.query.redirect_to } }).catch((err) => {});
                        } else {
                            this.$router.push("/verifyOtp").catch((err) => {});
                        }
                        // ==================== END NEW CODE ====================
                    }
                } else {
                    this.loggedIn = false;
                    let routePath = this.$route.path.split("/")[1];
                    switch (routePath) {
                        case "register":
                        case "registerInvited":
                            break;
                        default:
                        window.location.href = global.HRMS_URL;
                    }
                }
            }).catch(error => {
                this.$cookie.delete("Token", {
                    domain: "digicollect.com",
                });
                var res = document.cookie;
                var multiple = res.split(";");
                for(var i = 0; i < multiple.length; i++) {
                    var key = multiple[i].split("=");
                    document.cookie = key[0]+" =; expires = Thu, 01 Jan 1970 00:00:00 UTC";
                }
                setTimeout(() => {
                    window.location.href = global.HRMS_URL + '/login';
                }, 500);
            });
        },
        async HRMSLoggedInUser(){
            this.getOrganizationAndComp();
            this.$http.get("/get_loggedin_user")
            .then(response => {
                this.loadingGif = false;
                let userDetails = response.data.response
                userDetails['session_id'] = this.stored_session_id
                userDetails['user_has'] = this.user_has
                this.$store.commit('setLoggedInUser', userDetails);
                this.route_menus[1].submenus[0].route = `/employee_info/view_my_profile/${this.loggedInUser.session_id}/true/false?selected=profile`
                
                // Update Payroll settings route and visibility based on currency
                const settingsMenu = this.route_menus.find(menu => menu.name === 'Settings')
                if(settingsMenu && settingsMenu.submenus){
                    const isIndiaCurrency = userDetails.organisation && userDetails.organisation.currency && userDetails.organisation.currency.symbol == '₹'
                    if(isIndiaCurrency){
                        // Hide LMS (Leave Management) for India currency
                        settingsMenu.submenus = settingsMenu.submenus.filter(sub => sub.name !== 'LMS (Leave Management)')
                    }
                    const payrollSubmenu = settingsMenu.submenus.find(submenu => submenu.name === 'Payroll')
                    if(payrollSubmenu){
                        // Check currency to set correct payroll sub_type
                        if(isIndiaCurrency){
                            // Indian Payroll
                            payrollSubmenu.route = '/settings?type=payroll_settings&sub_type=earning_type_india'
                            payrollSubmenu.sub_route_queries = [{type:'payroll_settings', sub_type: 'earning_type_india'}]
                        } else {
                            // US Payroll
                            payrollSubmenu.route = '/settings?type=payroll_settings&sub_type=earning_type'
                            payrollSubmenu.sub_route_queries = [{type:'payroll_settings', sub_type: 'earning_type'}]
                        }
                    }
                }
                
                this.$http.defaults.headers.common.SessionID = this.loggedInUser.session_id || '';
                this.showaccess = false
                this.registerInterceptors();

                // Redirect attendance_manager to their dashboard on login
                if (this.loggedInUser.user_role === 'attendance manager' && !this.$route.path.startsWith('/attendance_management')) {
                    this.$router.push('/attendance_management/dashboard').catch(() => {})
                }
            })
            .catch(error => {
                this.registerInterceptors();
                // if(error.response.status == 403){
                //     this.$cookie.delete("Token");
                // this.$cookie.delete('Token', {
                //     domain: 'digicollect.com'
                // });
                // this.$cookie.delete('Token', {
                //     domain: '.digicollect.com'
                // });
                // this.$cookie.delete('Token', {
                //     domain: '.digicollect.com',
                //     path: '/'
                // });
                // this.$cookie.delete('Token', {
                // domain:document.location.hostname,
                // path:document.location.pathname
                // });
                // this.$cookie.delete('Token', {
                // domain:document.location.hostname,
                // });
                // this.$cookie.delete('Token', {
                // path:document.location.pathname
                // });
                // this.$cookie.delete('Token', {
                //     path: '/'
                // });
                //     var res = document.cookie;
                //     var multiple = res.split(";");
                //     for(var i = 0; i < multiple.length; i++) {
                //         var key = multiple[i].split("=");
                //         document.cookie = key[0]+" =; expires = Thu, 01 Jan 1970 00:00:00 UTC";
                //     }
                //     window.location.href = global.HRMS_URL + '/login';
                // }
            })
        },
        DeleteSessionToken(){
            sessionStorage.setItem("storeAppData", JSON.stringify(this._data));
            this.$cookie.delete("Token");
            this.$cookie.delete('Token', {
                domain: 'digicollect.com'
            });
            this.$cookie.delete('Token', {
                domain: '.digicollect.com'
            });
            this.$cookie.delete('Token', {
                domain: '.digicollect.com',
                path: '/'
            });
            this.$cookie.delete('Token', {
                domain:document.location.hostname,
                path:document.location.pathname
            });
            this.$cookie.delete('Token', {
                domain:document.location.hostname,
            });
            this.$cookie.delete('Token', {
                path:document.location.pathname
            });
            this.$cookie.delete('Token', {
                path: '/'
            });
            var res = document.cookie;
            var multiple = res.split(";");
            for(var i = 0; i < multiple.length; i++) {
                var key = multiple[i].split("=");
                document.cookie = key[0]+" =; expires = Thu, 01 Jan 1970 00:00:00 UTC";
            }
            // ?redirect_to=" + window.location.href
            setTimeout(() => {
                window.location.href = global.HRMS_URL + "/login";
            }, 500);
        },
        // registerInterceptors() {
        //     this.$http.interceptors.request.use(
        //         config => {
        //             if (this.$cookie.get('Token')) {
        //                 config.headers.Authorization = this.$cookie.get(
        //                     'Token'
        //                 )
        //             }
        //             return config
        //         },
        //         error => {
        //             return Promise.reject(error)
        //         }
        //     )
        //     this.$http.interceptors.response.use(undefined, err => {
        //         if(err.response.status == '403') {
        //             this.switch_accessable = true
        //             this.error_msg = err.response.data.reason || ''
        //             setTimeout(() => {
        //                 this.$modal.show('SwitchAccessableCompany')
        //                 EventBus.$emit('ZindexChangeStart')
        //             }, 500);
        //             // this.$cookie.delete("Token");
        //             // this.$cookie.delete('Token', {
        //             //     domain: 'digicollect.com'
        //             // });
        //             // this.$cookie.delete('Token', {
        //             //     domain: '.digicollect.com'
        //             // });
        //             // this.$cookie.delete('Token', {
        //             //     domain: '.digicollect.com',
        //             //     path: '/'
        //             // });
        //             // this.$cookie.delete('Token', {
        //             //     domain:document.location.hostname,
        //             //     path:document.location.pathname
        //             // });
        //             // this.$cookie.delete('Token', {
        //             //     domain:document.location.hostname,
        //             // });
        //             // this.$cookie.delete('Token', {
        //             //     path:document.location.pathname
        //             // });
        //             // this.$cookie.delete('Token', {
        //             //     path: '/'
        //             // });
        //             // var res = document.cookie;
        //             // var multiple = res.split(";");
        //             // for(var i = 0; i < multiple.length; i++) {
        //             //     var key = multiple[i].split("=");
        //             //     document.cookie = key[0]+" =; expires = Thu, 01 Jan 1970 00:00:00 UTC";
        //             // }
        //             // // ?redirect_to=" + window.location.href
        //             // setTimeout(() => {
        //             //     window.location.href = global.HRMS_URL + "/login";
        //             // }, 500);
        //         } else {
        //             return Promise.reject(err)
        //         }
        //     })
        // },
        // registerInterceptors() {
        //     this.$http.interceptors.request.use(
        //         config => {
        //             const fullUrl = (config.baseURL || "") + config.url
        //             // Allow only APIs starting with testhrmsApi.digicollect.com
        //             if (fullUrl.startsWith(global.HRMS_API)) {
        //                 const token = this.$cookie.get("Token")
        //                 if (token) {
        //                     config.headers.Authorization = token
        //                 }
        //             }
        //             return config
        //         },
        //         error => Promise.reject(error)
        //     )

        //     this.$http.interceptors.response.use(
        //         response => response,
        //         err => {
        //             const fullUrl = ((err.config?.baseURL) || "") + (err.config?.url || "")
        //             // const url = err.config?.url || ""
        //             // Handle only APIs starting with testhrmsApi.digicollect.com
        //             // if (fullUrl.startsWith(global.HRMS_API)) {
        //                 if (err.response?.status === 403) {
        //                     this.switch_accessable = true
        //                     this.error_msg = err.response.data.reason || ""
        //                     if(this.error_msg !== 'User not Active'){
        //                         if(this.error_msg !== 'Access Denied. Please try again.')
        //                         {
        //                             setTimeout(() => {
        //                                 this.$modal.show("SwitchAccessableCompany")
        //                                 EventBus.$emit("ZindexChangeStart")
        //                             }, 500)
        //                         }
        //                     }
        //                 }
        //             // }
        //             return Promise.reject(err)
        //         }
        //     )
        // },
        registerInterceptors() {
            this.$http.interceptors.request.use(
                config => {
                    if (this.$cookie.get('Token')) {
                        config.headers.Authorization = this.$cookie.get(
                            'Token'
                        )
                    }
                    return config
                },
                error => {
                    return Promise.reject(error)
                }
            )
            this.$http.interceptors.response.use(undefined, err => {
                if(err.response.status == '403') {
                    this.switch_accessable = true
                    this.error_msg = err.response.data.reason || ''
                    if(this.error_msg !== 'User not Active'){
                        if(this.error_msg !== 'Access Denied. Please try again.')
                        {
                            setTimeout(() => {
                                this.$modal.show("SwitchAccessableCompany")
                                EventBus.$emit("ZindexChangeStart")
                            }, 500)
                        }
                    }
                } else {
                    return Promise.reject(err)
                }
            })
        },
        hideaccessdenial() {
            this.showaccess = false
            this.$cookie.delete('Token', {domain: 'digicollect.com'});
            window.location.href = global.AUTH_SERVICE+"?redirect_to="+global.HRMS_URL;
        },
	  	load() {
			if(this.$cookie.get('Token',{domain:"digicollect.com"})) {
				this.$http.defaults.headers.common.Authorization = this.$cookie.get('Token');
                if (this.$route.path == "/subscription") {
                    this.$router.push("/").catch((err) => {});
                }
			} else {
				window.location.href = global.HRMS_URL;
			}
			this.getLoggedInUser();
	  	},
        scrollToBottom(){
            this.$nextTick(function () {
                this.$refs.containerDiv.scrollTop = 10000;
            });
        },
        handleStyles () {
            // Red style to the body tag for the home page
            if (['/subscription'].includes(this.$route.path)) document.body.className = 'bg-white'
            // Pink style to the body tag for all other pages
            else if (document.body.classList.contains('bg-white')) document.body.className = 'bg-white'
        },
        scrollToTop() {
			this.$nextTick(function(){
                this.$refs.containerDiv.scrollTop = 0;
                window.scrollTo(0,0);
			})
		},
        scrollToTopPhone() {
			this.$nextTick(function(){
                this.$refs.containerDiv.scrollTop = 800;
                window.scrollTo(800,0);
			})
		}
    },
    computed: {
        session_id() {
			return this.$store.getters.session_id
		},
        user_id() {
			return this.$store.getters.user_id
		},
		loggedInUser() {
			return this.$store.getters.loggedInUser
		},
        userSettings() {
            return this.$store.state.store.userSettings
        },
        getGeneralSettings() {
            return this.$store.state.store.getGeneralSettings
        },
        crmDetails() {
            return this.$store.state.store.crmDetails
        },
        fcmDetails() {
            return this.$store.getters.fcmDetails;
        }
	},
    watch: {
        '$route' (to,from) {
            this.handleStyles()
            
            // ==================== OLD CODE (Commented for reference) ====================
            // This old code handled redirects but didn't properly preserve the intended destination
            // It would redirect to login with window.location.href but the logic was incomplete
            /*
            if (to.path != "/register" && from.path == "/login" && !this.$cookie.get("Token")) {
                if (window.location.pathname != '/') {
                    if(this.$route.query.hasOwnProperty('redirect_to')) {
                    } else {
                        this.$router.push("/login?redirect_to=" + window.location.href).catch((errr) => {
                            this.$router.push("/login?redirect_to=" + window.location.href)
                        });
                    }
                } else {
                    if(this.$route.params.comp_id){
                        this.$router.push("/login?redirect_to=" + window.location.href)
                    } else {
                        this.$router.push("/login").catch((errr) => {
                            this.$router.push("/login")
                        });
                    }
                }
            }
            if (this.$cookie.get("Token") && to.path == '/login') {
                this.$router.push("/").catch((err) => {});
            }
            */
            // ==================== END OLD CODE ====================
            
            // ==================== NEW CODE (Deep Linking Support) ====================
            // Router guard now handles redirect logic for unauthenticated users
            // This watcher only handles the case when user is already logged in and tries to access login page
            // Modified to check for redirect_to parameter and redirect to intended destination
            if (this.$cookie.get("Token") && to.path == '/login') {
                // Check if there's a redirect_to in query params after login
                if (this.$route.query.redirect_to) {
                    window.location.href = this.$route.query.redirect_to;
                } else {
                    this.$router.push("/").catch((err) => {});
                }
            }
            // ==================== END NEW CODE ====================
        },
        "$route.path": function (path) {
            if (this.$cookie.get("Token") && path == '/verifyOtp') {
                this.otpVerified ? this.$router.push("/").catch((err) => {}) : this.$router.push("/verifyOtp").catch((err) => {});
            }
            if ( this.$cookie.get("Token") && path == "/subscription") {
                this.$router.push("/").catch((err) => {});
            }
            if (this.$cookie.get("Token") && path == '/login') {
                this.$router.push("/").catch((err) => {});
            }
        },
        'activeRefresh': function (val) {
            if(val) {
                this.load();
            }
        },
        isIpad(){
            if(isTablet){
                this.isIpad = true
            }
            else{
                this.isIpad = false
            }
        }
    },
	async mounted() {
        EventBus.$on('recallGetLoggedInUser', () => {
            this.load()
        })
        EventBus.$on('SwitchCompanySuccessNew',() =>{
            this.switch_success = true;
            setTimeout(() => {
                EventBus.$emit('ZindexChangeStart')
                this.$modal.show('switch-success');
            }, 500);
        })
        this.$bus.on('SwitchCompanySuccessNew',(data) =>{
            this.new_token = data.token
            localStorage.setItem('newToken', JSON.stringify(this.new_token))
            this.switch_success = true;
            setTimeout(() => {
                EventBus.$emit('ZindexChangeStart')
                this.$modal.show('switch-success');
            }, 500);
        })
        EventBus.$on('ZindexChangeStart', () => {
            document.getElementById('mobile_menu').style.zIndex = '0'
            document.getElementById('main-navbar').style.zIndex = '1';
            document.getElementById('router-relative').style.zIndex = '1';
        });
        EventBus.$on('ZindexChangeEnd', () => {
            document.getElementById('main-navbar').style.zIndex = '222';
            document.getElementById('mobile_menu').style.zIndex = '9';
            document.getElementById('router-relative').style.zIndex = '0';
        });
        this.$bus.on('ZindexChangeStart', () => {
            document.getElementById('mobile_menu').style.zIndex = '0'
            document.getElementById('main-navbar').style.zIndex = '1';
            document.getElementById('router-relative').style.zIndex = '1';
        });
        this.$bus.on('ZindexChangeEnd', () => {
            document.getElementById('main-navbar').style.zIndex = '222';
            document.getElementById('mobile_menu').style.zIndex = '9';
            document.getElementById('router-relative').style.zIndex = '0';
        });
        setTimeout(() => {
            if (this.$cookie.get("Token")) {
                // User is authenticated
                
                // ==================== OLD CODE (Commented for reference) ====================
                /*
                if (this.$route.path == "/login" || this.$route.path == "/subscription") {
                    this.$router.push("/").catch((err)=>{
                        if(this.$route.path == '/') {
                        } else {
                            this.$router.push("/").catch((err) => {})
                        }
                    });
                }
                this.load()
                */
                // ==================== END OLD CODE ====================
                
                // ==================== NEW CODE (Deep Linking Support) ====================
                // Modified to check for redirect_to parameter after successful authentication
                if (this.$route.path == "/login" || this.$route.path == "/subscription") {
                    // Check if there's a redirect_to parameter
                    if (this.$route.query.redirect_to) {
                        window.location.href = this.$route.query.redirect_to;
                    } else {
                        this.$router.push("/").catch((err)=>{
                            if(this.$route.path == '/') {
                            } else {
                                this.$router.push("/").catch((err) => {})
                            }
                        });
                    }
                }
                this.load()
                // ==================== END NEW CODE ====================
            } else {
                // User is not authenticated
                
                // ==================== OLD CODE (Commented for reference) ====================
                /*
                this.loadingGif = false;
                this.register = true;
                if (window.location.pathname != '/') {
                    if(this.$route.query.hasOwnProperty('redirect_to')) {} 
                    else {
                        this.$router.push("/login" ).catch((errr) => {
                            this.$router.push("/login")
                        });
                    }
                } 
                else {
                    if(this.$route.params.comp_id){
                        this.$router.push("/login?redirect_to=" + window.location.href)
                    } else {
                        this.$router.push("/login").catch((errr) => {
                            this.$router.push("/login")
                        });
                    }
                }
                */
                // ==================== END OLD CODE ====================
                
                // ==================== NEW CODE (Deep Linking Support) ====================
                // Router guard will handle redirecting to login with redirect_to parameter
                // Just ensure we're on login page if not authenticated
                this.loadingGif = false;
                this.register = true;
                if (this.$route.path !== '/login' && this.$route.path !== '/verifyOtp' && this.$route.path !== '/pagenotfound') {
                    // Router guard will catch this and redirect with proper redirect_to
                }
                // ==================== END NEW CODE ====================
            }
        }, 500);
        let browserLang = navigator.language.split('-')[0]
        localStorage.setItem('language', browserLang)
        localStorage.getItem('language');
        this.handleStyles()
		EventBus.$on("scrollToTop", () => this.scrollToTop());
        EventBus.$on("scrollToBottom", () => this.scrollToBottom());
        EventBus.$on("scrollToTopPhone", () => this.scrollToTopPhone());
        const userAgent = navigator.userAgent.toLowerCase();
        this.isTablet = /(iphone|ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent);
        // EventBus.$on('UnSubscribe', () => {
        //     this.unSubscribeTokenToTopic();
        // })
    },
    destroyed(){
        EventBus.$off('scrollToTop')
        EventBus.$off('scrollToBottom')
        EventBus.$off('scrollToTopPhone')
    }
}
</script>
<style scoped>
.ps {
  position: relative;
  overflow: hidden !important;
  overflow-anchor: none;
  -ms-overflow-style: none;
  touch-action: auto;
  -ms-touch-action: auto;
}
.ps {
  -ms-touch-action: auto;
  touch-action: auto;
  overflow: hidden !important;
  -ms-overflow-style: none;
}
.ps {
  -ms-touch-action: auto;
  touch-action: auto;
  overflow: hidden !important;
  -ms-overflow-style: none;
}
.ps-container {
  position: relative;
}
.access-denied-alert {
    position: relative !important;
    top: 30% !important;
    justify-content: center !important;
    display: flex !important;
    font-size: 18px;
    text-align: center;
    color: #0d84f2;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    min-height: 220px;
    position: relative;
    background: #ffffff;
    -webkit-box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2),
        0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
    box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2),
        0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
    -moz-box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2),
        0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
    filter: progid:DXImageTransform.Microsoft.Blur(PixelRadius=3, MakeShadow=true, ShadowOpacity=0.30);
    -ms-filter: "progid:DXImageTransform.Microsoft.Blur(PixelRadius=3,MakeShadow=true,ShadowOpacity=0.30)";
    zoom: 1;
    border-radius: 18px;
    width: 50%;
    margin: 0 auto;
}

.access-denied-alert span {
    justify-content: center !important;
    display: block !important;
    margin: 0 auto;
    margin-bottom: 20px;
    text-align: center;
}
.access-denied-alert span img {
    width: 40px;
}
.overflow-hidden{
    overflow: hidden !important;
}
.transform-screen{
    transform: rotate(90deg);
}
#full-screen:fullscreen {
	width: 100%;
	height: 100%;
}

/* prefix for Chrome & Safari */
#full-screen:-webkit-full-screen {
	width: 100%;
	height: 100%;
}

.fw-600{
    font-weight: 600 !important;
}
.content-boxnew{
    margin-left: 250px !important;
}
.content-blocks{
    /* margin-left: 120px;
    margin-right: 10px; */
    margin-top: 15px;
}
@media screen and (max-width: 992px) {
    .content-blocks{
        margin-left: 12px;
        margin-right: 12px;
    }
    .content-boxnew{
        margin-left: 0px !important;
    }
    .page-layout.blank{
        margin-left: 0px !important;
    }
}
</style>